import { useEffect, useRef, useState } from 'react';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { ClearSession } from '../../Common/Common';
import { Table2 } from '../../Common/userlocationtable.js';
import Footer from '../../Layout/FooterComponent.js';


const UserLocationHistoryForm = () => {
    const cookies = new Cookies();
    useEffect(() => {
        document.title = 'User location history'
    }, [])
    const [mapUrl, setMapUrl] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [ColoredRow, setColoredRow] = useState('');
    const [tableData, setTableData] = useState([])
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    console.log(FromDate, "fsfdsf")
    const [userCodedropdown, setUserCode] = useState([])

    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [SessionClear, SetSessionClear] = useState(false);
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        FromDate: '',
        ToDate: '',
        UserCode: '',
        FromTime: '',
        ToTime: '',
    });
    const inputRefs = useRef([]);
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')

    const userCodeDropdownList = async () => {
        let Condition = " And UserGroupID In(3,4)";
        let TextPart = "UserName"
        let ValuePart = "UserCode"
        let TableName = "UserMaster"
        let data = { Token, LoginUserCode, Condition, TextPart, ValuePart, TableName }
        await fetch('/api/User/BindDropDownList',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                if (res.status === "SUCCESS") {
                    setUserCode(res.dropDownList);
                }
                else if (res.message === "EXPIRED") {

                    SetSessionClear(true);
                    ClearSession();
                }
                else if (res.message !== "") {
                    toast.error(res.message, {

                    })
                }

            }).catch((err) =>
                toast.error(err.message, {
                    position: 'top-center'
                })
            );

    };
    const handleClear = () => {
        setFormData({
            UserCode: '',
            FromDate: '',
            ToDate: '',
            Time: ''
        });
        setColoredRow(null)
        setTableData([])
        inputRefs.current['txtfromDate'].focus();
    }


        const ViewTracking = async () => {
            setIsLoading(true);
            let data = {
                ...formData,
                Token,
                LoginUserCode,
                FromDate: document.getElementById('txtfromDate').value,
                ToDate: document.getElementById('txtDateTo').value,
            };
            const loaderTimeout = new Promise(resolve => setTimeout(resolve, 4000));

            try {
                const response = await fetch(`/api/ReportController/GetUserCurrentMap`, {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                const responseData = await response.json();

                if (responseData.status === "SUCCESS") {
                    setMapUrl(responseData.map); 
                    await loaderTimeout; 
                    window.open(responseData.map, "_blank"); 
                } else if (responseData.message === "EXPIRED") {
                    navigate('/login'); 
                } else if (responseData.status === "ERROR") {
                    await loaderTimeout; 
                    toast.error(responseData.message);
                }

            } catch (err) {
                await loaderTimeout; 
                toast.error(err.message);
            } finally {
                setIsLoading(false); 
            }
        };

    const handleSubmit = async (CurrentPage) => {
        setIsLoading(true)
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let data = {
            ...formData, Token, LoginUserCode, FromDate: document.getElementById('txtfromDate').value, ToDate
                : document.getElementById('txtDateTo').value,
            Type: 'S',
            PageIndex: `${PageIndex}`

        }
        await fetch(`/api/ReportController/GetUserCurrentLocation`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            const responseData = await response.json();
            if (responseData.Status === "SUCCESS") {
                setTableData(responseData);
            } else if (responseData.message === "EXPIRED") {
                navigate('/login')
            }

            else if (responseData.Status === "ERROR") {
                toast.error(responseData.Message, {

                })
                setTableData([])


            }
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err.message, {

            })
            setIsLoading(false)
        }, [/*filterData*/])
    };
    const handleChange1 = (event, value) => {
        handleSubmit(value)
    };

    const handleDownloadExcel = async () => {
        const requestBody = {
            ...formData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        try {
            const response = await fetch('/api/ReportController/GetUserCurrentLocation', {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: requestHeaders,
            });
            const res = await response.json();
            if (res.Status === "SUCCESS") {

                const workbook = XLSX.utils.book_new();
                let worksheet = XLSX.utils.aoa_to_sheet([
                    res?.HeadersValue
                    ,
                    ...res?.Data?.map((records) =>
                        res.HeadersKey?.map((data, i) =>
                            records[data]
                        )
                    ),
                ]);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `UserLocationHistory.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return
            }
        } catch (err) {
            toast.error(err.message, {

            });
        }
    };
    useEffect(() => {
        userCodeDropdownList()
    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'User Location History'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">


                                    <div className="col-lg-3  col-md-4 col-sm-6 ">
                                        <div className="fields ">
                                            <label className="form-label">From Date  <span className="Required">*</span></label>
                                            <DatePicker
                                                selected={FromDate}

                                                ref={ref => (inputRefs.current['txtfromDate'] = ref)}
                                                id='txtfromDate'
                                                className="form-control"
                                                placeholderText='From Date'
                                                dateFormat={'dd-MMM-yyyy h:mm aa'}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                autoComplete='off'
                                                onChange={(date) => setFromDate(date)
                                                }
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtDateTo'].focus();
                                                    };
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">

                                        <div className="fields">
                                            <label className='form-label'> To Date<span className="Required">*</span></label>
                                            <DatePicker
                                                selected={ToDate}
                                                ref={ref => (inputRefs.current['txtDateTo'] = ref)}
                                                id='txtDateTo'
                                                className="form-control"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy h:mm aa'}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                autoComplete='off'
                                                onChange={(date) => setToDate(date)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlVenueCode'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">User <span className="Required">*</span></label>
                                            <select
                                                ref={ref => (inputRefs.current['txtUserCode'] = ref)}
                                                id="inputState"
                                                className="form-select"
                                                value={formData.UserCode}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, UserCode: e.target.value })

                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}
                                            >
                                                <option value=''>Please Select User</option>
                                                {
                                                    userCodedropdown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.valuePart}>{item.textPart}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button d-flex align-items-center justify-center">
                                            <button className="button save-btn info" onClick={handleSubmit}>
                                                <i className="fa fa-search" />  Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            <button className="button View-Tracking" onClick={ViewTracking} disabled={isLoading}>
                                                <a href={mapUrl || '#'} target="_blank" onClick={(e) => e.preventDefault()}>
                                                    {isLoading ? (
                                                        < div className="d-flex">
                                                            <div className="loader" /> <span style={{ color:"#ED721D"} }>Loading...</span>
                                                        </div>

                                                    ) : (
                                                        <>
                                                            <i className="bi bi-pin-map-fill" /> View Tracking
                                                        </>
                                                    )}
                                                </a>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className='heading-box1 d-block d-sm-flex'>
                                <div className="heading">
                                    <h6 className='m-0 mb-2 mb-sm-0 font-weight-bold text-primary' style={{ fontSize: "1rem" }}>{`${(tableData.length !== 0) ? 'Total Records : ' + tableData?.TotalRecord : 'No Record Found'}`}</h6>
                                </div>
                            </div>
                            {tableData.length !== 0 ?
                                <Table2
                                    tableData={tableData}
                                    currentPageNo={currentPageNo}
                                    handleChange1={handleChange1}
                                /> : <></>}

                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer theme='colored' />
            {SessionClear ? <ClearSession /> : <></>}
            <Footer />
        </>
    )
}
export default UserLocationHistoryForm
